import { MaskedLine, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, title, desc, testid = "page-hero" }) => (
  <section className="relative overflow-hidden bg-cream pt-32 pb-14 sm:pt-40 sm:pb-20" data-testid={testid}>
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-blush/50 blur-3xl"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-gold/10 blur-3xl"
    />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      {eyebrow && <Eyebrow className="mb-5">{eyebrow}</Eyebrow>}
      <h1 className="gold-hairline max-w-3xl font-serif text-4xl font-semibold leading-[1.08] text-ink sm:text-5xl lg:text-6xl">
        <MaskedLine delay={0.05}>{title}</MaskedLine>
      </h1>
      {desc && (
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-ink/65 sm:text-lg">{desc}</p>
      )}
    </div>
  </section>
);

export default PageHero;
